import { Component } from '@theme/component';
import { ThemeEvents, ZoomMediaSelectedEvent } from '@theme/events';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

export class MediaGallery extends Component {
  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, { signal });
    this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected, this.#handleZoomMediaSelected, {
      signal,
    });

    // Autoplay
    if (this.presentation === 'carousel') {
      this.#startAutoplay();
      this.addEventListener('mouseenter', () => this.#stopAutoplay(), { signal });
      this.addEventListener('mouseleave', () => this.#startAutoplay(), { signal });
    }
  }

  #controller = new AbortController();
  #autoplayInterval = null;
  #autoplayDelay = 3000;

  #startAutoplay() {
    this.#stopAutoplay();
    this.#autoplayInterval = setInterval(() => {
      const slideshow = this.slideshow;
      if (!slideshow) return;
      const total = this.refs.media?.length ?? 0;
      if (total < 2) return;
      const current = slideshow.currentIndex ?? 0;
      const next = (current + 1) % total;
      slideshow.select(next);
    }, this.#autoplayDelay);
  }

  #stopAutoplay() {
    if (this.#autoplayInterval) {
      clearInterval(this.#autoplayInterval);
      this.#autoplayInterval = null;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#stopAutoplay();
    this.#controller.abort();
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html } = detail;
        const newMediaGallery = html.querySelector('media-gallery');
        if (!newMediaGallery) return;

        this.replaceWith(newMediaGallery);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[media-gallery] Event promise rejected:', error);
      });
  };

  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  preloadImage(index) {
    const zoomDialogMedia = this.refs.zoomDialogComponent?.refs.media[index];
    if (!zoomDialogMedia) return;

    this.refs.zoomDialogComponent?.loadHighResolutionImage(zoomDialogMedia);
  }

  get slideshow() {
    return this.refs.slideshow;
  }

  get media() {
    return this.refs.media;
  }

  get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}